export var ColorMode;
(function (ColorMode) {
    ColorMode["Day"] = "day";
    ColorMode["Night"] = "night";
})(ColorMode || (ColorMode = {}));
//# sourceMappingURL=ColorMode.js.map